
export const BIDDING_TAGS = {
    BID_LIST: "getBidList",
} as const;